/**
 * 一覧の下に出す「まだ続きがあります」と「さらに表示する」（docs/06 決定22・issue #242）。
 *
 * 管理画面の一覧はどれも同じ言葉・同じ形で続きを知らせます（呼び名を揃える・#286 L-5）。
 * 操作のあとの読み直し（`refresh`）ができなかったときも、ここでお知らせします（issue #424）。
 */
import type { ReactNode } from 'react';
import type { PagedList } from '../api/paged-list.js';
import { Button } from './ui/Button.js';
import { ResultBanner } from './ui/ResultBanner.js';
import { endsWithRequest, withReason } from '../format/sentence.js';

export function LoadMoreFooter({ list }: { list: PagedList<unknown> }): ReactNode {
  if (list.error !== null || list.items === null) return null;
  return (
    <>
      {list.hasMore ? (
        <div className="admin-row-actions">
          <p className="admin-note">
            まだ続きがあります（いま{list.items.length}件を表示しています）。
          </p>
          <Button
            variant="secondary"
            busy={list.loadingMore}
            disabled={list.refreshing}
            onClick={() => void list.loadMore()}
          >
            さらに表示する
          </Button>
        </div>
      ) : null}
      {list.moreError !== null ? (
        <ResultBanner
          tone="error"
          message={withReason(`続きを読み込めませんでした`, list.moreError)}
          // 理由の文がすでにお願いで終わっているときは、同じお願いを重ねない
          {...(endsWithRequest(list.moreError)
            ? {}
            : { nextStep: '少し時間をおいて、もう一度「さらに表示する」を押してください。' })}
        />
      ) : null}
      {list.refreshError !== null ? (
        // 操作のあとの読み直しができなかった（issue #424）。出ている行は操作の前のまま
        <ResultBanner
          tone="error"
          message={withReason(`一覧を最新の内容にできませんでした`, list.refreshError)}
          nextStep="表示している一覧は、操作の前のままです。少し時間をおいて、画面を開き直してください。"
        />
      ) : null}
    </>
  );
}
